import type { Media } from '@/types/media';

export const mediaList: Media[] = [
  {
    id: 'mv-01',
    title: '星海远征',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20adventure%20movie%20poster%2C%20lone%20astronaut%20silhouette%20against%20glowing%20nebula%2C%20deep%20blue%20and%20orange%20tones%2C%20cinematic%20dramatic%20lighting%2C%20minimal%20clean%20composition&width=400&height=600&seq=mv-01&orientation=portrait',
    genres: ['科幻', '冒险'],
    region: '美国',
    year: 2024,
    rating: 8.7,
    views: '2.3亿',
    duration: '152分钟',
    episodes: 0,
    status: '',
    director: '克里斯·诺兰',
    actors: ['马修·麦康', '安娜·海瑟薇', '汤姆·哈迪'],
    description: '人类赖以生存的星球正走向衰亡，一支由宇航员组成的远征队穿越虫洞，去寻找人类新的家园。面对时间的流逝与亲情的羁绊，他们必须在星海深处做出抉择。',
    tags: ['科幻', '太空', '冒险', '高分'],
  },
  {
    id: 'mv-02',
    title: '暗夜追凶',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Suspense%20crime%20thriller%20movie%20poster%2C%20detective%20in%20rainy%20neon%20alley%20at%20night%2C%20moody%20dark%20blue%20atmosphere%2C%20flashlight%20beam%2C%20gritty%20cinematic%20tone&width=400&height=600&seq=mv-02&orientation=portrait',
    genres: ['悬疑', '犯罪'],
    region: '中国',
    year: 2023,
    rating: 8.2,
    views: '1.6亿',
    duration: '128分钟',
    episodes: 0,
    status: '',
    director: '陈默',
    actors: ['张译', '王砚辉', '周冬雨'],
    description: '一桩尘封十年的悬案重新浮出水面，落魄刑警凭借蛛丝马迹层层追查，在暗夜中与真凶展开一场智力与意志的较量，真相远比想象更令人震惊。',
    tags: ['悬疑', '犯罪', '烧脑'],
  },
  {
    id: 'mv-03',
    title: '时光情书',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20young%20couple%20under%20warm%20sunset%20light%2C%20soft%20orange%20and%20peach%20tones%2C%20dreamy%20bokeh%2C%20tender%20emotional%20mood&width=400&height=600&seq=mv-03&orientation=portrait',
    genres: ['爱情', '剧情'],
    region: '韩国',
    year: 2024,
    rating: 7.9,
    views: '9800万',
    duration: '118分钟',
    episodes: 0,
    status: '',
    director: '朴恩慧',
    actors: ['全智美', '宋康昊', '李到晛'],
    description: '一封跨越二十年的信件，让两个曾经的恋人重新相遇。时光改变了容貌，却带不走记忆深处那份温柔，一段关于遗憾与重逢的治愈故事。',
    tags: ['爱情', '治愈', '温情'],
  },
  {
    id: 'mv-04',
    title: '峰顶之巅',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Action%20adventure%20climbing%20movie%20poster%2C%20climber%20on%20dramatic%20snowy%20mountain%20peak%2C%20cold%20blue%20sky%20and%20white%20snow%2C%20high%20tension%20scale%2C%20epic%20poster%20composition&width=400&height=600&seq=mv-04&orientation=portrait',
    genres: ['动作', '冒险'],
    region: '美国',
    year: 2022,
    rating: 8.4,
    views: '3.1亿',
    duration: '141分钟',
    episodes: 0,
    status: '',
    director: '詹姆斯·卡隆',
    actors: ['杰克·雷诺', '艾玛·斯通'],
    description: '一支登山队在攀登世界最难峰顶的途中遭遇暴风雪，队友之间必须彼此信任才能活下来。这是一场与自然极限抗衡的生死旅程。',
    tags: ['动作', '冒险', '震撼'],
  },
  {
    id: 'mv-05',
    title: '无声之境',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%2C%20lone%20figure%20in%20misty%20empty%20forest%2C%20desaturated%20cold%20green%20grey%20palette%2C%20tense%20eerie%20atmosphere%2C%20cinematic%20fog&width=400&height=600&seq=mv-05&orientation=portrait',
    genres: ['惊悚', '悬疑'],
    region: '英国',
    year: 2023,
    rating: 7.6,
    views: '7600万',
    duration: '109分钟',
    episodes: 0,
    status: '',
    director: '奥利弗·里德',
    actors: ['汤姆·希德', '凯拉·奈特'],
    description: '一个与世隔绝的小镇里，居民们突然失去了听觉，恐惧在沉默中蔓延。真相隐藏在每个人不愿提及的往事里。',
    tags: ['惊悚', '悬疑', '氛围'],
  },
  {
    id: 'mv-06',
    title: '江湖剑影',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20martial%20arts%20movie%20poster%2C%20swordsman%20silhouette%20with%20flying%20leaves%2C%20ink%20wash%20style%2C%20deep%20blue%20and%20gold%20accents%2C%20elegant%20oriental%20composition&width=400&height=600&seq=mv-06&orientation=portrait',
    genres: ['武侠', '动作'],
    region: '中国',
    year: 2021,
    rating: 8.1,
    views: '2.0亿',
    duration: '136分钟',
    episodes: 0,
    status: '',
    director: '徐克安',
    actors: ['张震', '刘亦菲', '易烊千玺'],
    description: '乱世之中，一把失落的宝剑牵动江湖各方势力。年轻剑客为洗清师门冤屈踏上征途，在恩怨情仇间领悟侠义真谛。',
    tags: ['武侠', '动作', '国风'],
  },
  {
    id: 'mv-07',
    title: '机器人小新',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20animated%20sci-fi%20family%20movie%20poster%2C%20friendly%20little%20robot%20with%20big%20glowing%20eyes%2C%20bright%20colorful%20playful%20background%2C%20warm%20cheerful%20cartoon%20style&width=400&height=600&seq=mv-07&orientation=portrait',
    genres: ['动画', '科幻'],
    region: '日本',
    year: 2024,
    rating: 8.6,
    views: '1.8亿',
    duration: '106分钟',
    episodes: 0,
    status: '',
    director: '新海诚亮',
    actors: ['花泽香菜', '神木隆之介'],
    description: '一个被遗落在垃圾场的小机器人被善良的男孩捡回家，两个不搭调的伙伴在冒险中建立起深厚友谊，教会彼此什么是家与爱。',
    tags: ['动画', '合家欢', '治愈'],
  },
  {
    id: 'mv-08',
    title: '沙漠玫瑰',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=War%20drama%20movie%20poster%2C%20woman%20standing%20in%20vast%20golden%20desert%20under%20harsh%20sun%2C%20dusty%20amber%20tones%2C%20resilient%20emotional%20mood%2C%20cinematic%20wide%20feel&width=400&height=600&seq=mv-08&orientation=portrait',
    genres: ['剧情', '战争'],
    region: '法国',
    year: 2022,
    rating: 7.8,
    views: '6400万',
    duration: '124分钟',
    episodes: 0,
    status: '',
    director: '吕克·贝松',
    actors: ['玛丽昂·歌迪', '让·迪雅尔丹'],
    description: '战火蔓延的年代，一位女医生独自留在沙漠中的营地，守护着一群无辜的平民。她用坚韧与善意，在荒芜之地种下希望的玫瑰。',
    tags: ['剧情', '战争', '人文'],
  },
  {
    id: 'mv-09',
    title: '都市之光',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20comedy%20drama%20movie%20poster%2C%20downtown%20city%20skyline%20with%20warm%20evening%20lights%2C%20young%20professionals%20walking%2C%20lively%20orange%20and%20blue%20night%20tones&width=400&height=600&seq=mv-09&orientation=portrait',
    genres: ['喜剧', '剧情'],
    region: '中国',
    year: 2025,
    rating: 7.4,
    views: '5200万',
    duration: '112分钟',
    episodes: 0,
    status: '',
    director: '宁浩宇',
    actors: ['沈腾', '马丽', '雷佳音'],
    description: '三个在大城市打拼的普通人，因一场乌龙事故被命运捆绑在一起。笑中带泪的都市故事，讲述平凡人如何照亮彼此的生活。',
    tags: ['喜剧', '都市', '轻松'],
  },
  {
    id: 'mv-10',
    title: '深海奇缘',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20ocean%20adventure%20movie%20poster%2C%20diver%20swimming%20among%20glowing%20jellyfish%20and%20coral%2C%20teal%20and%20violet%20deep%20sea%20tones%2C%20magical%20dreamy%20underwater%20scene&width=400&height=600&seq=mv-10&orientation=portrait',
    genres: ['奇幻', '冒险'],
    region: '美国',
    year: 2023,
    rating: 8.0,
    views: '1.4亿',
    duration: '133分钟',
    episodes: 0,
    status: '',
    director: '吉尔莫·托罗',
    actors: ['赞达亚', '雅各布·特伦'],
    description: '一名海洋生物学家在深海考察时发现神秘的海底文明，她必须在守护秘密与揭开真相之间做出选择，一段奇幻的深海奇缘就此展开。',
    tags: ['奇幻', '冒险', '视觉'],
  },
  {
    id: 'mv-11',
    title: '迷雾山庄',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20mystery%20movie%20poster%2C%20old%20creepy%20mansion%20in%20thick%20fog%2C%20single%20lit%20window%2C%20dark%20purple%20grey%20palette%2C%20eerie%20gothic%20atmosphere&width=400&height=600&seq=mv-11&orientation=portrait',
    genres: ['恐怖', '悬疑'],
    region: '日本',
    year: 2022,
    rating: 7.2,
    views: '4300万',
    duration: '98分钟',
    episodes: 0,
    status: '',
    director: '中田秀夫',
    actors: ['桥本环奈', '山崎贤人'],
    description: '一群人为参加遗产继承测试，来到与世隔绝的山庄。当迷雾封住所有出口，他们逐渐发现，这座山庄藏着比遗产更可怕的秘密。',
    tags: ['恐怖', '悬疑', '惊悚'],
  },
  {
    id: 'mv-12',
    title: '永恒花园',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%2C%20lush%20timeless%20garden%20with%20glowing%20flowers%2C%20couple%20silhouette%20among%20bloom%2C%20emerald%20green%20and%20golden%20light&width=400&height=600&seq=mv-12&orientation=portrait',
    genres: ['奇幻', '爱情'],
    region: '英国',
    year: 2024,
    rating: 8.3,
    views: '1.1亿',
    duration: '127分钟',
    episodes: 0,
    status: '',
    director: '乔·赖特',
    actors: ['蒂莫西·查拉', '西尔莎·罗南'],
    description: '在一座时间静止的永恒花园里，园丁与来访的旅人相遇相爱。可花园之外的现实正一点点侵蚀这里，他们的爱能否抵挡时间的洪流？',
    tags: ['奇幻', '爱情', '唯美'],
  },
  {
    id: 'mv-13',
    title: '星际快递',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Fun%20sci-fi%20comedy%20movie%20poster%2C%20quirky%20space%20delivery%20courier%20with%20package%20on%20colorful%20planet%2C%20playful%20vibrant%20orange%20and%20teal%20retro%20style&width=400&height=600&seq=mv-13&orientation=portrait',
    genres: ['喜剧', '科幻'],
    region: '韩国',
    year: 2023,
    rating: 7.5,
    views: '7200万',
    duration: '104分钟',
    episodes: 0,
    status: '',
    director: '奉俊昊民',
    actors: ['宋仲基', '金泰梨'],
    description: '银河系最不靠谱的快递员接到一份神秘包裹，横跨数颗星球的送件之旅充满意外与笑料，而包裹里的东西竟能改变整个宇宙的命运。',
    tags: ['喜剧', '科幻', '轻松'],
  },
  {
    id: 'mv-14',
    title: '铁血战线',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=War%20epic%20movie%20poster%2C%20soldiers%20advancing%20through%20smoke%20and%20fire%2C%20dramatic%20red%20and%20black%20tones%2C%20heroic%20tense%20battlefield%2C%20cinematic%20intensity&width=400&height=600&seq=mv-14&orientation=portrait',
    genres: ['战争', '剧情'],
    region: '中国',
    year: 2022,
    rating: 8.5,
    views: '2.8亿',
    duration: '149分钟',
    episodes: 0,
    status: '',
    director: '冯小刚毅',
    actors: ['吴京', '张涵予', '段奕宏'],
    description: '抗美援朝战场上，一支侦察小队深入敌后执行几乎不可能完成的任务。在钢铁与炮火之间，他们用血肉之躯筑起一道不倒的战线。',
    tags: ['战争', '剧情', '热血'],
  },
  {
    id: 'tv-01',
    title: '长安秘事',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20tv%20series%20poster%2C%20ancient%20Tang%20dynasty%20city%20at%20night%20with%20lanterns%2C%20scholar%20detective%20figure%2C%20deep%20blue%20and%20gold%20oriental%20palette&width=400&height=600&seq=tv-01&orientation=portrait',
    genres: ['古装', '悬疑'],
    region: '中国',
    year: 2024,
    rating: 8.8,
    views: '45.6亿',
    duration: '',
    episodes: 36,
    status: '更新中',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围'],
    description: '长安城接连发生离奇命案，一位年轻的司直与神秘画师联手调查，在繁华盛世的表象下，一步步揭开足以撼动朝局的惊天秘密。',
    tags: ['古装', '悬疑', '权谋', '热播'],
  },
  {
    id: 'tv-02',
    title: '都市恋歌',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20tv%20series%20poster%2C%20elegant%20couple%20on%20city%20rooftop%20at%20dusk%2C%20warm%20pink%20and%20orange%20skyline%20tones%2C%20fashionable%20romantic%20mood&width=400&height=600&seq=tv-02&orientation=portrait',
    genres: ['都市', '爱情'],
    region: '中国',
    year: 2024,
    rating: 7.6,
    views: '32.1亿',
    duration: '',
    episodes: 40,
    status: '已完结',
    director: '李木戈',
    actors: ['杨幂', '许凯', '白鹿'],
    description: '两个在职场中互相较劲的年轻人，从对手到伙伴再到恋人，在熙熙攘攘的都市里谱写一段关于成长与心动的恋歌。',
    tags: ['都市', '爱情', '甜宠'],
  },
  {
    id: 'tv-03',
    title: '未来边界',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20tv%20series%20poster%2C%20cyber%20city%20with%20holographic%20towers%2C%20lone%20figure%20facing%20vast%20skyline%2C%20electric%20teal%20and%20violet%20neon%20tones&width=400&height=600&seq=tv-03&orientation=portrait',
    genres: ['科幻', '冒险'],
    region: '美国',
    year: 2023,
    rating: 8.9,
    views: '28.4亿',
    duration: '',
    episodes: 24,
    status: '已完结',
    director: '乔纳森·诺兰',
    actors: ['伊娃·格林', '佩德罗·帕斯'],
    description: '在人工智能统治的未来世界，一群反抗者试图突破城市边界，寻找传说中的自由之地。科技与人性的冲突，在这里被推向极致。',
    tags: ['科幻', '冒险', '烧脑', '高分'],
  },
  {
    id: 'tv-04',
    title: '医者仁心',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Medical%20drama%20tv%20series%20poster%2C%20dedicated%20doctor%20in%20bright%20hospital%20corridor%2C%20clean%20white%20and%20calm%20blue%20tones%2C%20hopeful%20professional%20atmosphere&width=400&height=600&seq=tv-04&orientation=portrait',
    genres: ['医疗', '剧情'],
    region: '中国',
    year: 2023,
    rating: 8.4,
    views: '26.7亿',
    duration: '',
    episodes: 32,
    status: '已完结',
    director: '张黎',
    actors: ['靳东', '海清', '童瑶'],
    description: '急诊科里每天都在上演生死时速，一群医护工作者在压力与温情之间坚守初心，用专业与仁心守护每一位患者的生命。',
    tags: ['医疗', '剧情', '感动'],
  },
  {
    id: 'tv-05',
    title: '庄园风云',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=British%20historical%20drama%20tv%20series%20poster%2C%20grand%20country%20manor%20with%20elegant%20guests%2C%20muted%20green%20and%20gold%20period%20tones%2C%20refined%20aristocratic%20mood&width=400&height=600&seq=tv-05&orientation=portrait',
    genres: ['剧情', '历史'],
    region: '英国',
    year: 2022,
    rating: 8.7,
    views: '18.2亿',
    duration: '',
    episodes: 20,
    status: '已完结',
    director: '朱利安·费洛斯',
    actors: ['玛吉·史密斯', '休·博内威利'],
    description: '一座古老庄园见证了一个家族三代人的兴衰沉浮。在时代的浪潮中，贵族与仆人之间的命运紧密交织，谱写一曲恢弘的时代挽歌。',
    tags: ['剧情', '历史', '经典'],
  },
  {
    id: 'tv-06',
    title: '甜品店奇缘',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20romantic%20comedy%20tv%20series%20poster%2C%20charming%20dessert%20shop%20with%20colorful%20cakes%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20sweet%20cheerful%20mood&width=400&height=600&seq=tv-06&orientation=portrait',
    genres: ['喜剧', '爱情'],
    region: '韩国',
    year: 2024,
    rating: 7.8,
    views: '14.9亿',
    duration: '',
    episodes: 16,
    status: '更新中',
    director: '金恩淑',
    actors: ['朴叙俊', '金高银'],
    description: '一位天才甜点师与一位挑剔的美食评论家，在同一家甜品店里不打不相识。甜蜜的攻势与傲娇的真心，一场味蕾与心动的双重较量。',
    tags: ['喜剧', '爱情', '甜宠'],
  },
  {
    id: 'tv-07',
    title: '迷雾侦探',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20mystery%20detective%20tv%20series%20poster%2C%20investigator%20examining%20evidence%20board%20in%20dim%20room%2C%20cold%20blue%20and%20amber%20noir%20lighting%2C%20tense%20suspenseful&width=400&height=600&seq=tv-07&orientation=portrait',
    genres: ['悬疑', '犯罪'],
    region: '中国',
    year: 2024,
    rating: 8.5,
    views: '21.5亿',
    duration: '',
    episodes: 28,
    status: '更新中',
    director: '五百',
    actors: ['潘粤明', '王泷正', '张译'],
    description: '经验丰富的刑警与思维缜密的犯罪心理学家搭档，联袂侦破一桩桩扑朔迷离的案件，在迷雾般的线索中，还原人性的真相。',
    tags: ['悬疑', '犯罪', '烧脑'],
  },
  {
    id: 'tv-08',
    title: '少年足球队',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Youth%20sports%20anime%20tv%20series%20poster%2C%20teenage%20soccer%20players%20celebrating%20on%20green%20field%2C%20bright%20energetic%20blue%20and%20yellow%20tones%2C%20dynamic%20upbeat%20mood&width=400&height=600&seq=tv-08&orientation=portrait',
    genres: ['运动', '青春'],
    region: '日本',
    year: 2022,
    rating: 8.2,
    views: '12.3亿',
    duration: '',
    episodes: 26,
    status: '已完结',
    director: '长井龙雪',
    actors: ['梶裕贵', '花江夏树'],
    description: '一群怀揣梦想的少年为了全国大赛的目标集结成队，在汗水与泪水中成长，用青春和热血书写属于他们的足球传奇。',
    tags: ['运动', '青春', '励志'],
  },
  {
    id: 'tv-09',
    title: '王室密闻',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Royal%20period%20drama%20tv%20series%20poster%2C%20regal%20palace%20hall%20with%20crown%20and%20throne%2C%20rich%20burgundy%20and%20gold%20tones%2C%20majestic%20secretive%20mood&width=400&height=600&seq=tv-09&orientation=portrait',
    genres: ['剧情', '历史'],
    region: '英国',
    year: 2023,
    rating: 8.0,
    views: '9.8亿',
    duration: '',
    episodes: 18,
    status: '已完结',
    director: '彼得·摩根',
    actors: ['海伦·米伦', '马特·史密斯'],
    description: '王室光鲜的背后藏着无数不为人知的秘密。一场宫廷风波将年轻的继承者卷入权力漩涡，他必须在责任与自我之间找到平衡。',
    tags: ['剧情', '历史', '宫廷'],
  },
  {
    id: 'tv-10',
    title: '山城烟火',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20family%20life%20drama%20tv%20series%20poster%2C%20lively%20mountain%20city%20alley%20at%20dusk%20with%20food%20stalls%2C%20cozy%20orange%20and%20green%20tones%2C%20nostalgic%20homely%20mood&width=400&height=600&seq=tv-10&orientation=portrait',
    genres: ['家庭', '剧情'],
    region: '中国',
    year: 2025,
    rating: 8.3,
    views: '16.4亿',
    duration: '',
    episodes: 30,
    status: '更新中',
    director: '孔笙',
    actors: ['黄磊', '海清', '沙溢'],
    description: '在依山而建的老城里，一个普通家庭的三代人在柴米油盐中相互扶持。平凡日子里的悲欢离合，汇成了最动人的山城烟火。',
    tags: ['家庭', '剧情', '温情'],
  },
];